<script>
import { defineComponent } from 'vue';
import EmailValidate from '@/helpers/emailValidate';

export default defineComponent({
    name: 'emailOrderModal',
    setup() {},
    data() {
        return {
            openModal: false,
            email: null,
        }
    },
    props: {
        emailOrder: Object
    },
    computed: {
        accessToken() {
            return this.$store.getters['auth/accessToken'];
        }
    },
    methods: {
        onSubmit() {

            let emailRef = this.$refs.emailRef.validate();
            if (!emailRef) {
                return false;
            }

            if (!EmailValidate.ValidateEmail(this.email)) {
                this.$store.dispatch('message/sendMessage', {message: 'Invalid Email Address', type: 'negative', position: 'bottom', icon: 'warning'}, {root:true});
                return;
            }

            this.$store.dispatch('customer/emailOrder', [this.email, this.emailOrder, this.accessToken])
        },
        onReset () {
            this.email=null;
            this.$refs.emailRef.resetValidation()
      }
    },
    watch: {
        emailOrder() {
            if (this.emailOrder != null) {
                this.openModal = true;
            } else { 
                this.openModal = false;
                this.email = null;
            }
        }
    }
})
</script>

<template>
    <q-dialog v-model="openModal" persistent :square=true>

      <q-card style="min-width: 350px" class="bg-dark text-white">
      <form @submit.prevent.stop="onSubmit" @reset.prevent.stop="onReset" class="q-gutter-md">
        <q-card-section>
          <div class="text-h6">Email address</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
        
          <q-input :dark=true ref="emailRef" color="cyan-7" :standout=false filled square dense v-model="email" type="email" hint="Email" :rules="[val => !!val || 'Field is required']" autofocus @keyup.enter="prompt = false">
            <template v-slot:prepend>
                <q-icon name="email" />
            </template>
          </q-input>
        
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn  flat label="Cancel" color="warning" @click="$store.commit('customer/setEmailOrder', [null, null])" v-close-popup />
          <q-btn :outline=true label="Send" color="cyan-7" @click="onSubmit()" />
        </q-card-actions>
        </form>
      </q-card>

    </q-dialog>
</template>